import { DownloadDocumentBtn } from "../../components/DownloadDocumentBtn";
// MUI
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export const CreditNoteHeader = ({ no }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">Credit Note - {no}</Typography>
      <DownloadDocumentBtn docType="PDF" docNo={no} path="printPostedCrMemo" />
    </Stack>
  );
};
